/**
 * Machine-readable runs (device ids, TR-069 paths, MACs, IPs, opaque refs,
 * timestamps) are LTR even inside Persian text. `.mono` isolates them so bidi
 * never reorders `acs-device:HWTC…` or `192.168.1.7`; `dir="ltr"` is set
 * explicitly because jsdom/some engines ignore the CSS-only form.
 */
export interface MonoProps {
  value: string;
  /** Abbreviate long ids visually while keeping the full value selectable. */
  head?: number;
  title?: string;
  className?: string;
  as?: 'span' | 'code';
}

export function Mono({ value, head, title, className = '', as = 'span' }: MonoProps) {
  const shown = head && value.length > head ? `${value.slice(0, head)}…` : value;
  const Tag = as;
  return (
    <Tag
      dir="ltr"
      className={`mono ${className}`}
      title={title ?? value}
      data-testid={as === 'code' ? 'mono-code' : undefined}
    >
      {shown}
    </Tag>
  );
}

/** A cross-service ref (`nas:…`, `sub:…`, `policy:…`) or the "unset" marker. */
export function RefText({
  value,
  emptyLabel = 'ثبت نشده',
}: {
  value: string | null | undefined;
  emptyLabel?: string;
}) {
  if (!value) {
    return <span className="text-ink-faint">{emptyLabel}</span>;
  }
  return <Mono value={value} />;
}
